import { useMutation } from '@tanstack/react-query';
import { GET, GET_POLICIES_DATA } from '../../../../services';

export const useGetPolicyData = ({ onSuccess } = {}) => {
  return useMutation({
    mutationFn: async () => {
      const response = await GET(GET_POLICIES_DATA());
      return response.result;
    },
    onSuccess: (result) => {
      onSuccess?.(result);
    },
  });
};
